/** @graphql cc **/

import gql from 'graphql-tag';

export const ReadUserWithRestrictionsQuery = gql`
	query ReadUserWithRestrictionsQuery(
		$contentId: ID!
		$status: [String]
		$draftShareId: String
		$readUserStart: Int = 0
	) {
		content(id: $contentId, status: $status, draftShareId: $draftShareId) {
			nodes {
				id
				restrictions {
					read {
						restrictions {
							userWithRestrictions(start: $readUserStart) {
								count
								nodes {
									type
									displayName
									accountId
									profilePicture {
										path
									}
									hasSpaceViewPermission
									hasSpaceEditPermission
									permissionType
									restrictingContent {
										id
										links {
											webui
											base
										}
									}
								}
								pageInfo {
									hasNextPage
									endCursor
								}
							}
						}
					}
				}
			}
		}
	}
`;

export const ReadGroupsQuery = gql`
	query ReadGroupsQuery(
		$contentId: ID!
		$status: [String]
		$draftShareId: String
		$readGroupStart: Int = 0
	) {
		content(id: $contentId, status: $status, draftShareId: $draftShareId) {
			nodes {
				id
				restrictions {
					read {
						restrictions {
							group(start: $readGroupStart) {
								count
								nodes {
									id
									name
									permissionType
								}
								pageInfo {
									hasNextPage
									endCursor
								}
							}
						}
					}
				}
			}
		}
	}
`;

export const EditUserWithRestrictionsQuery = gql`
	query EditUserWithRestrictionsQuery(
		$contentId: ID!
		$status: [String]
		$draftShareId: String
		$editUserStart: Int = 0
	) {
		content(id: $contentId, status: $status, draftShareId: $draftShareId) {
			nodes {
				id
				restrictions {
					update {
						restrictions {
							userWithRestrictions(start: $editUserStart) {
								count
								nodes {
									type
									displayName
									accountId
									profilePicture {
										path
									}
									hasSpaceViewPermission
									hasSpaceEditPermission
									permissionType
									restrictingContent {
										id
										links {
											webui
											base
										}
									}
								}
								pageInfo {
									hasNextPage
									endCursor
								}
							}
						}
					}
				}
			}
		}
	}
`;

export const EditGroupsQuery = gql`
	query EditGroupsQuery(
		$contentId: ID!
		$status: [String]
		$draftShareId: String
		$editGroupStart: Int = 0
	) {
		content(id: $contentId, status: $status, draftShareId: $draftShareId) {
			nodes {
				id
				restrictions {
					update {
						restrictions {
							group(start: $editGroupStart) {
								count
								nodes {
									id
									name
									permissionType
								}
								pageInfo {
									hasNextPage
									endCursor
								}
							}
						}
					}
				}
			}
		}
	}
`;

export const RestrictionsDialogQuery = gql`
	query RestrictionsDialogQuery(
		$contentId: ID!
		$status: [String]
		$draftShareId: String
		$readUserStart: Int = 0
		$readGroupStart: Int = 0
		$editUserStart: Int = 0
		$editGroupStart: Int = 0
	) {
		content(id: $contentId, status: $status, draftShareId: $draftShareId) {
			nodes {
				id
				ancestors {
					id
					hasViewRestrictions
					links {
						webui
					}
				}
				hasInheritedRestrictions
				hasRestrictions
				hasViewRestrictions
				title
				type
				status
				subType
				operations {
					operation
					targetType
				}
				restrictions {
					read {
						restrictions {
							userWithRestrictions(start: $readUserStart) {
								count
								nodes {
									type
									displayName
									accountId
									profilePicture {
										path
									}
									hasSpaceViewPermission
									hasSpaceEditPermission
									permissionType
									restrictingContent {
										id
										links {
											webui
											base
										}
									}
								}
								pageInfo {
									hasNextPage
									endCursor
								}
							}
							group(start: $readGroupStart) {
								count
								nodes {
									id
									name
									permissionType
								}
								pageInfo {
									hasNextPage
									endCursor
								}
							}
						}
					}
					update {
						restrictions {
							userWithRestrictions(start: $editUserStart) {
								count
								nodes {
									type
									displayName
									accountId
									profilePicture {
										path
									}
									hasSpaceViewPermission
									hasSpaceEditPermission
									permissionType
									restrictingContent {
										id
										links {
											webui
											base
										}
									}
								}
								pageInfo {
									hasNextPage
									endCursor
								}
							}
							group(start: $editGroupStart) {
								count
								nodes {
									id
									name
									permissionType
								}
								pageInfo {
									hasNextPage
									endCursor
								}
							}
						}
					}
				}
				space {
					id
					containsExternalCollaborators
					externalCollaboratorCount
				}
			}
		}
		user: confluence_atlassianUser(current: true) {
			id
			displayName
			photos {
				value
				isPrimary
			}
		}
		tenant: confluence_tenantContext {
			editions {
				confluence
			}
		}
	}
`;
